import KYCPending from "./KYC";
import KYCUpload from "./KYCUpload";
import KYCRequested from "./KYCRequested";
import KYCVerified from "./KYCVerified";
import KYCRejected from "./KYCRejected";
export default KYCPending;
export { KYCUpload, KYCRequested, KYCVerified, KYCRejected };
